import React, { memo } from 'react';
export const BonusSection = memo(function BonusSection() {
  const bonuses = [{
    id: 1,
    icon: '🎁',
    title: 'Kit "Cero Miedo"',
    subtitle: 'Para el que sabe que es fácil pero no se anima a arrancar.',
    desc: '25 ejercicios prácticos paso a paso para que pierdas el miedo a tocar algo y ganes confianza real desde el primer día.',
    value: '$9.900'
  }, {
    id: 2,
    icon: '🔍',
    title: 'Checklist "Casa Segura"',
    subtitle: 'Auditá tu propia casa antes de que pase algo grave.',
    desc: 'Los 20 riesgos eléctricos más comunes en hogares argentinos. Revisá tu casa en 30 minutos y sabé exactamente qué arreglar primero.',
    value: '$6.900'
  }, {
    id: 3,
    icon: '🛒',
    title: 'Guía "Herramientas Inteligentes"',
    subtitle: 'Qué comprar, qué no comprar y dónde comprarlo en Argentina.',
    desc: 'Armá tu kit básico sin gastar de más. Qué herramientas mínimas necesitás para resolver el 90% de los problemas de tu casa.',
    value: '$5.900'
  }, {
    id: 4,
    icon: '📋',
    title: 'Guía Rápida de Emergencias',
    subtitle: 'Qué hacer cuando se va la luz o salta el diferencial.',
    desc: 'El paso a paso para los problemas más comunes que pasan de noche, los fines de semana o cuando menos lo esperás.',
    value: '$7.900'
  }];
  const infiniteBonuses = [...bonuses, ...bonuses, ...bonuses];
  return <section className="py-16 bg-white border-t border-gray-200 overflow-hidden" data-id="element-20">
      <div className="max-w-5xl mx-auto px-4" data-id="element-21">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-22">
          <div className="inline-block bg-amber-50 text-amber-600 px-5 py-1.5 rounded-full font-black text-[11px] uppercase tracking-widest mb-4 border border-amber-200" data-id="element-23">
            🎁 BONOS EXCLUSIVOS
          </div>
          <h2 className="text-[24px] md:text-4xl font-black text-gray-900 mb-4 leading-tight max-w-3xl mx-auto" data-id="element-24">
            Con tu Megapack Electricista en Casa recibís{' '}
            <span className="text-amber-600" data-id="element-25">
              4 regalos que arrancan desde el día uno:
            </span>
          </h2>
        </div>
      </div>

      {/* Carrusel Infinito */}
      <div className="relative w-full overflow-hidden" data-id="element-26">
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-27" />
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-28" />

        <div className="animate-scroll-left flex gap-5 py-4 px-4" data-id="element-29">
          {infiniteBonuses.map((bono, index) => <div key={index} className="flex-shrink-0 w-[280px] md:w-[320px] bg-gray-50 rounded-2xl border border-amber-200 p-6 shadow-md flex flex-col relative overflow-hidden" data-id="element-30">
              {/* Ribbon */}
              <div className="absolute top-0 right-0 bg-amber-500 text-white text-[10px] font-black uppercase tracking-widest px-4 py-1 rounded-bl-lg" data-id="element-31">
                Bono #{bono.id}
              </div>

              {/* Header */}
              <div className="mb-4 pr-16" data-id="element-32">
                <div className="flex items-center gap-3 mb-2" data-id="element-33">
                  <span className="text-3xl" data-id="element-34">{bono.icon}</span>
                  <h3 className="text-[16px] font-black text-gray-900 leading-tight" data-id="element-35">
                    {bono.title}
                  </h3>
                </div>
                <p className="text-amber-600 font-bold text-[12px] leading-snug mt-2" data-id="element-36">
                  "{bono.subtitle}"
                </p>
              </div>

              {/* Desc */}
              <p className="text-gray-600 text-[12px] leading-relaxed mb-5 flex-1" data-id="element-37">
                {bono.desc}
              </p>

              {/* Valor */}
              <div className="flex items-center justify-between bg-white p-3 rounded-xl border border-gray-200 mt-auto" data-id="element-38">
                <span className="text-gray-500 text-[11px] font-bold uppercase tracking-wider" data-id="element-39">
                  Valor Real: <span className="line-through" data-id="element-40">{bono.value}</span>
                </span>
                <span className="text-green-600 font-black text-[12px] uppercase tracking-wider" data-id="element-41">
                  INCLUIDO
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
});